import { Amplify } from '@aws-amplify/core';
import { getUrl as getUrl$1 } from './internal/getUrl.mjs';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function getUrl(input) {
    return getUrl$1(Amplify, input);
}

export { getUrl };
//# sourceMappingURL=getUrl.mjs.map
